import * as React from "react";
import { createContext, useState, useMemo } from "react";
import Store from "logic/local-storage/Store";
import useHotkey from "hooks/useHotkey";
export const ScratchpadContext = createContext(void 0);
export const ScratchpadProvider = ({ children, loginName }) => {
  const localStorageItem = `gl-scratchpad-${loginName}`;
  const scratchpadStore = Store.get(localStorageItem) || {};
  const [isScratchpadVisible, setVisibility] = useState(scratchpadStore.opened || false);
  const scratchpadContextValue = useMemo(() => {
    const toggleScratchpadVisibility = () => {
      const currentStorage = Store.get(localStorageItem);
      Store.set(localStorageItem, { ...currentStorage, opened: !isScratchpadVisible });
      setVisibility(!isScratchpadVisible);
    };
    const setScratchpadVisibility = (opened) => {
      const currentStorage = Store.get(localStorageItem);
      Store.set(localStorageItem, { ...currentStorage, opened });
      setVisibility(opened);
    };
    return {
      isScratchpadVisible,
      localStorageItem,
      setScratchpadVisibility,
      toggleScratchpadVisibility
    };
  }, [isScratchpadVisible, localStorageItem]);
  useHotkey({
    actionKey: "show-scratchpad-modal",
    callback: () => {
      setVisibility(true);
    },
    scope: "general"
  });
  return /* @__PURE__ */ React.createElement(ScratchpadContext.Provider, { value: scratchpadContextValue }, children);
};
